<template>
  <div class="appTable">
    <div class="appTable__tool" v-if="showTopControl">
      <div class="appTable__tool__left">
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            title="刷新"
            class="refreshBtnClass"
            @click="DoRefresh"
            :class="{ rotation_ani: isRefreshing }"
          ></el-button>
          <el-button
            type="info"
            icon="el-icon-sunrise"
            title="回到默认"
            class="refreshBtnClass"
            @click="DoInit"
          ></el-button>
        </el-button-group>

        <slot name="tools"></slot>
        <slot name="third"></slot>
      </div>
      <div class="appTable__tool__right">
        <el-button
          type="primary"
          :icon="isFilter ? 'el-icon-receiving' : 'el-icon-files'"
          :title="isFilter ? '收起筛选选项' : '更多筛选选项'"
          @click="doFilter"
        ></el-button>

        <el-input v-model="searchword" placeholder="快速搜索内容" @change="onSearchwordChanged">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <el-collapse-transition>
      <!-- 状态显示 -->
      <div class="appTable_tool_filter" v-show="isFilter">
        <template v-if="FilterStatusDefault && packup">
          <selectTableFilterStatus
            ref="selectTableFilterStatus"
            :showReviewOption="showReviewOption"
            :showDealOption="showDealOption || showDeal"
            @onDataChanged="onTableFilterStatusDataChanged"
          ></selectTableFilterStatus>
        </template>
        <slot name="filter"></slot>
        <slot name="secondFilter"></slot>
        <slot name="thirdFilter"></slot>
      </div>
    </el-collapse-transition>
    <div class="appTable__tool__fixed">
      <slot name="fixedFilter"></slot>
    </div>

    <!-- 默认的Table控件 -->
    <el-table
      :data="datas"
      stripe
      border
      class="appTable__datas"
      header-row-class-name="table-header-row"
      v-loading="loadingTable"
    >
      <template v-if="expand">
        <el-table-column type="expand">
          <template slot-scope="props">
            <slot name="expand" :props="props"></slot>
          </template>
        </el-table-column>
      </template>

      <el-table-column
        type="index"
        width="50">
      </el-table-column>
      
      <template v-for="item in columns">

        <template v-if="item.scope">
          <el-table-column
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <slot name="columnSlotFirst" :props="scope"></slot>
            </template>
          </el-table-column>
        </template>
        <template v-if="!item.scope">
          <!-- 设置时间 -->
          <template v-if="item.prop == 'cdate'">
            <el-table-column
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                {{ dateFormat("YYYY-mm-dd HH:MM:SS", scope.row.cdate) }}
              </template>
            </el-table-column>
            <!-- <template slot-scope="scope">
                  {{dateFormat("YYYY-mm-dd",scope.row.cdate)}} 1111
                </template>                 -->
          </template>

            <template v-else-if="item.convert">
              <el-table-column
                :label="item.label"
                :width="item.width"            
              >
                <template #default="scope">
                <!-- <p>{{item.convert(scope.row.prop)}}</p>            -->
                <p>{{item.convert(scope.row[item.prop])}}</p>           
              </template>
              </el-table-column>        
          </template>

          <template v-else>
            <el-table-column
              :prop="item.prop"
              :label="item.label"
              :key="item.prop"
              :width="item.width"
            >
            </el-table-column>
          </template>
        </template>
      </template>

      <el-table-column
        label="当前状态"
        width="100px"
        v-if="packup && showTopControl"
      >
        <template slot-scope="scope">
          <StatusTag
            :status="scope.row.status"
            :showReviewOption="showReviewOption"
          ></StatusTag>
          <!-- <el-tag
          :type="getTableStatusClass(scope.row.status)">{{scope.row.statusStr}}</el-tag>-->
          <!-- <p :class="getTableStatusClass(scope.row.status)">{{scope.row.statusStr}}</p> -->
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" class-name="column__tool">
        <template slot-scope="scope">
          <template v-if="tableToolConfig.canRecover">
            <StartTableBtn
              v-if="scope.row.status == 1"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row.name || scope.row.username"
              @onSuccess="onToolSuccess"
            ></StartTableBtn>
          </template>
          <template v-if="tableToolConfig.canEdit">
            <router-link
              :to="{ path: baseUrl + '/edit', query: { id: scope.row.id } }"
            >
              <!-- 显示处理 -->
              <template v-if="showReviewOption">
                <!-- 未启用，审核失败，启用中都可以修改 -->
                <el-button
                  type="primary"
                  size="mini"
                  v-if="
                    scope.row.status == 1 ||
                    scope.row.status == 4 ||
                    scope.row.status == 0
                  "
                  plain
                  icon="el-icon-edit"
                  class="column__tool__buttom"
                  >修改&nbsp;</el-button
                >
              </template>

              <template v-else>
                <!-- 只要不是删除，都可以修改 -->
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.status != 2 && scope.row.status != 3"
                  plain
                  icon="el-icon-edit"
                  class="column__tool__buttom"
                  >修改&nbsp;</el-button
                >
              </template>
            </router-link>
          </template>
          <template v-if="tableToolConfig.canDelete">
            <DeleteTableBtn
              v-if="scope.row.status == 1"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row[titleProp]"
              @onSuccess="onToolSuccess"
            ></DeleteTableBtn>
          </template>
          <template v-if="tableToolConfig.canDisable">
            <DisableTableBtn
              v-if="scope.row.status == 0"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row[titleProp]"
              @onSuccess="onToolSuccess"
            ></DisableTableBtn>
          </template>

          <template v-if="showDealOption">
            <router-link
              :to="{ path: baseUrl + '/deal', query: { id: scope.row.id } }"
            >
              <!-- 审核 -->
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.status == 3 || scope.row.status == 4"
                plain
                icon="el-icon-edit"
                class="column__tool__buttom"
                >处理&nbsp;</el-button
              >
            </router-link>
          </template>
          <template v-if="showDeal && scope.row.status == 3">
            <el-button
              type="primary"
              size="mini"
              plain
              icon="el-icon-edit"
              class="column__tool__buttom"
              >查看审核状态&nbsp;</el-button
            >
            <el-button
              type="info"
              size="mini"
              plain
              icon="el-icon-close"
              class="column__tool__buttom"
              >取消审核&nbsp;</el-button
            >
          </template>
          <slot name="bindInfo" :data="scope.row"></slot>
          <slot name="columnSlotTool" :props="scope.row.id"></slot>
        </template>
      </el-table-column>
    </el-table>

    <div class="appTable__footer">
      <div class="appTable__footer_page">
        <el-pagination
          :pager-count="5"
          class="el-pag"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="sizes,total,next, pager,prev,jumper "
          :total="total"
        ></el-pagination>
      </div>
      <div class="appTable__footer__info">
        <p>
          <i class="el-icon-info mr-1"></i>
          <slot name="table__footer__info"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

import { selectTableFilterStatus } from "@/core/select";
import {
  StatusTag,
  DisableTableBtn,
  StartTableBtn,
  DeleteTableBtn,
} from "./comp";

import { getListApi } from "@/api/core/table/table";
import { dateFormat } from "@/utils/index";

export default {
  name: "new-table-container",
  props:{
    serverUrl: {
      type: String
    },
    columns : {
      type: Array
    },
    tableToolConfig : {
      type: Object
    },
    FilterStatusDefault:{
      type: Boolean
    },
    expand:{
      type: Boolean,
      default: false
    },
    packup:{
      type: Boolean,
      default: true
    },
    baseUrl: {
      type: String
    },
    showReviewOption:{
      type: Boolean,
      default: false
    },
    showDealOption:{
      type: Boolean,
      default: false
    },
    showDeal:{
      type: Boolean,
      default: false
    },
    autoInit:{
      type: Boolean,
      default: true
    },
    searchProp: {
      type: String
    },
    showTopControl:{
      type: Boolean,
      default: true
    },
    splice:{
      type: Boolean,
      default: true
    },
    titleProp: {
      type: String
    },
  },
  components: {
    selectTableFilterStatus,
    StatusTag,
    DisableTableBtn,
    StartTableBtn,
    DeleteTableBtn,
  },
  data() {
    return {
      isFilter : true, // 是否展开更多筛选项
      isRefreshing : false,
      loadingTable : false, // 正在加载表单

      datas : [], // table 数据
      // filter params
      searchword : "", // 搜索关键字
      status : 0,
      dataMap: new Map(), // 数据 map
      // 之后为table.ts添加参数添加判断

      // 分页
      currentPage : 1,
      pageSize : 10,
      total : 0
    }
  },
  methods:{
    initTable() {
      // 包裹参数
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let _this = this;
      let serverUrl = this.serverUrl;
      let tableFilterData = {
        status: _this.status,
        searchword: _this.searchword,
        searchProp: _this.searchProp,

        dataMap: _this.dataMap,
      };

      let start = (_this.currentPage - 1) * _this.pageSize;

      let tablePageData = {
        current: _this.currentPage,
        start: start,
        size: _this.pageSize,
      };

      _this.loadingTable = true;

      getListApi(serverUrl, tableFilterData, tablePageData)
        .then((response) => {
          let total = response.total;
          let datas;
          if (response.records) {
            datas = response.records;
          } else if (response.datas) {
            datas = response.datas;
          } else {
            datas = response;
          }
          _this.datas = datas;
          _this.total = total;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          _this.loadingTable = false;
        });
    },

    DoInit() {
      // 恢复默认
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.pageSize = 10;
      this.currentPage = 1;
      this.searchword = "";
      this.status = 0;
      this.initTable();
    },

    DoRefresh() {
      // 刷新
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let _this = this;
      if (!_this.isRefreshing) {
        _this.isRefreshing = true;

        _this.initTable();

        setTimeout(() => {
          _this.isRefreshing = false;
        }, 0.7 * 1000);
      }
    },

    dateFormat(fmt, date) {
      return dateFormat(fmt, date);
    },

    doFilter() {
      this.isFilter = !this.isFilter;
    },

    onToolSuccess() {
      this.initTable();
    },

    // 状态选择框/所属学习班改动
    onTableFilterStatusDataChanged(value) {
      this.status = value;
      this.currentPage = 1;
      this.initTable();
    },

    // 外部筛选框输入
    updateParams(pkey, pval) {
      if (!this.dataMap) {
        this.dataMap = new Map();
      }

      this.dataMap.set(pkey, pval);
      this.initTable();
    },


    // 分页
    handleSizeChange(p) {
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.pageSize = p;
      this.currentPage = 1;
      this.initTable();
    },

    handleCurrentChange(p) {
      this.currentPage = p;
      this.initTable();
    },

    onSearchwordChanged(){
      this.currentPage = 1;
      this.initTable();
    }
  },
  watch: {

  },
  created() {},
  // 生命周期钩子
  mounted() {
    if (this.autoInit && this.packup) {
      this.initTable();
    }
  }
}


</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
